// import { Authenticator } from '@aws-amplify/ui-react-native'; // native
import { Authenticator } from '@aws-amplify/ui-react'; // web
import { ConvexProviderWithAuth, ConvexReactClient } from 'convex/react';
import type { ReactNode } from 'react';
import { CognitoAuthEventListener } from './CognitoAuthEventListener';
import { useConvexCognitoAuth } from './useConvexCognitoAuth';

type AuthProvidersProps = {
  convexUrl: string;
  children: ReactNode;
};

/**
 * AWS Cognito and Convex authentication providers.
 * @param children
 * @param convexUrl
 */
export function AuthProviders({ children, convexUrl }: AuthProvidersProps) {
  return (
    <Authenticator.Provider>
      <CognitoAuthEventListener />
      <ConvexProviderWithAuth
        client={
          new ConvexReactClient(convexUrl, {
            unsavedChangesWarning: false,
            verbose: false,
          })
        }
        useAuth={useConvexCognitoAuth}
      >
        {children}
      </ConvexProviderWithAuth>
    </Authenticator.Provider>
  );
}
